import { render, staticRenderFns } from "./UrgentOrderModal.vue?vue&type=template&id=08efb2ac"
import script from "./UrgentOrderModal.vue?vue&type=script&lang=js"
export * from "./UrgentOrderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports